import script from "./BigScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./BigScreen.vue?vue&type=script&setup=true&lang=js"

import "./BigScreen.vue?vue&type=style&index=0&id=1e636039&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e636039"]])

export default __exports__